import { render, staticRenderFns } from "./ExposePatient.vue?vue&type=template&id=22325079&scoped=true&"
import script from "./ExposePatient.vue?vue&type=script&lang=js&"
export * from "./ExposePatient.vue?vue&type=script&lang=js&"
import style0 from "./ExposePatient.vue?vue&type=style&index=0&id=22325079&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22325079",
  null
  
)

export default component.exports